export default "__VITE_ASSET__BGSV6uVu__"